// extracted by mini-css-extract-plugin
module.exports = {"AsSeenIn":"styles-module--AsSeenIn--3A_mD","AsSeenIn__logos":"styles-module--AsSeenIn__logos--SLEt2","AsSeenIn__logo":"styles-module--AsSeenIn__logo--3KKxh"};